import React from 'react';

interface BadgeProps {
  label: string;
  color: string;
  bgColor: string;
}

export function Badge({ label, color, bgColor }: BadgeProps) {
  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${color} ${bgColor}`}>
      {label}
    </span>
  );
}
